import React from "react"
import { Box, Button, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { AlertSeeker } from "@ui-seeker/core"

export default function NotFoundPage() {
	const navigate = useNavigate()

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				flexDirection: 'column',
				minHeight: '100vh',
				textAlign: 'center',
				p: 2
			}}
		>
			<Typography variant="h1" color="text.primary" gutterBottom>
				404
			</Typography>
			<Typography variant="h5" color="text.secondary" gutterBottom>
				The page you’re looking for doesn’t exist.
			</Typography>
			<Button
				variant="contained"
				color="primary"
				onClick={() => navigate('/login')}
			>
				Go to Login
			</Button>
			<Box
				sx={{
					p: 2,
					mt: 2,
					mb: 3,
					maxWidth: 1 / 3,
				}}
			>
				<AlertSeeker
					disableAccordion
					isOpen={true}
					severity="info"
					title="Why im I seeing this?"
					open={true}
				>
					<Typography variant="body1" color="textSecondary" paragraph>
						We’re currently migrating to a new version of Price Seeker Rentacar.
						Please note that there may be inconsistencies when using links from the previous version in the new system. If you need any
						assistance, don't hesitate to contact us.
					</Typography>
				</AlertSeeker>
			</Box>
		</Box>
	)
}
